module.exports = __webpack_public_path__ + "img/viagem-disney-carro.15ceb9e8.jpeg";